import { Content } from '../../../components/layout/content';
import * as Button from '../../../components/button/button';
import { useParams } from 'react-router';
import usePageState from '../../../hooks/use-page-state';
import { Modes } from '../../../types/page-modes';
import { Icons } from '../../../components/icons/icons';
import { PaginatedTable } from '../../../components/table/paginated-table';
import * as Page from '../../../components/content/page-header';
import { Link } from 'react-router-dom';
import { PlacemarkEditor } from './placemark-editor';
import React, { useState } from 'react';
import { Query, usePagination } from '../../../hooks/use-pagination';
import { ActionColumn } from '../../../components/table/columns';

export const Placemarks = (): JSX.Element => {
  const [pageState, setPageState] = usePageState();
  const params = useParams();
  const [query, setQuery] = useState<Query>({});
  const { data } = usePagination('/placemarks', query);

  const columns = [
    { accessor: 'name', Header: 'Name', sort: true },
    { accessor: 'icon', Header: 'Place Mark Icon', Cell: (item: any): JSX.Element => {
      return item.row.original.icon ? <img src={item.row.original.icon} width={29} height={29} /> : <span />;
    } },
    { accessor: 'paletteSectionName', Header: 'Section Name' },
    { accessor: 'paletteName', Header: 'Palette Name' },
    ActionColumn({ onDelete: (item): void => setPageState(Modes.DELETE, item), onUpdate: (item): void => setPageState(Modes.UPDATE, item) })
  ];

  return <>
    <Content>
      <Page.Header>
        <Page.Title>
          <Link to={params.paletteId && params.sectionId ? `/settings/palettes/${params.paletteId}/sections/${params.sectionId}` : '/settings/palettes'} className="page-title-link">
            <Icons.LeftArrow className="page-header-back" />
            Palettes/PlaceMarks
          </Link>
        </Page.Title>
        <Page.SubTitle>
          Define the protocols used in DisasterAWARE.
          <div>
            <Button.LightBlackSmall onClick={(): void => setPageState(Modes.CREATE)}>
              <Icons.Add />
              Add Placemark
            </Button.LightBlackSmall>
          </div>
        </Page.SubTitle>
      </Page.Header>
      <PaginatedTable columns={columns} data={data} onChange={setQuery} />
    </Content>
    {![Modes.BROWSE, Modes.CANCEL].includes(pageState.mode) && <PlacemarkEditor pageState={pageState} setPageState={(pageState): void => setPageState(pageState)} />}
  </>;
};
